module["exports"] = [
  "Checking",
  "Savings",
  "Money Market",
  "Investment",
  "Home Loan",
  "Credit Card",
  "Auto Loan",
  "Personal Loan"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/finance/account_type.js
// module id = 724
// module chunks = 0